import { isPlatformBrowser, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {
    Component,
    Inject,
    LOCALE_ID,
    PLATFORM_ID,
    TransferState,
    inject,
} from '@angular/core';
import {
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
    RouterOutlet,
} from '@angular/router';
import { environment } from 'environments/environment';
import { OneSignal } from 'onesignal-ngx';
import { ArticleSchemaService } from './shared/ArticleSchema.service';
import { MetaService } from './shared/meta.service';
import { SharedModule } from './shared/shared.module';

declare const gtag: Function;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    providers: [{ provide: LOCALE_ID, useValue: 'fr' }],
    standalone: true,
    imports: [RouterOutlet, SharedModule],
    template: `
        <app-dynamic-schema
            pageTitle="Irbe7 - L'actualité de la bourse de Tunis"
            pageDescription="Suivez l'actualité boursiére et financiére en temps réel avec Irbe7.com. Analyses de marché, indices boursiers, actions, devises, matières premières et plus encore. la source d'information pour les investisseurs intelligents."
            pageUrl="https://irbe7.com/"
        >
            <router-outlet></router-outlet>
        </app-dynamic-schema>
    `,
})
export class AppComponent {
    transferState = inject(TransferState);
    isNavigating: boolean = true;

    constructor(
        private router: Router,
        private metaService: MetaService,
        @Inject(PLATFORM_ID) private platformId: any,
        private articleSchemaService: ArticleSchemaService
    ) {
        if (isPlatformBrowser(this.platformId))
            inject(OneSignal).init({
                appId: environment.onesignal_appId,
            });

        registerLocaleData(localeFr, 'fr');

        this.metaService.updateMetaTags({
            title: "Irbe7 - L'actualité de la bourse de Tunis",
            description: "Suivez l'actualité boursiére et financiére en temps réel avec Irbe7.com. Analyses de marché, indices boursiers, actions, devises, matières premières et plus encore. la source d'information pour les investisseurs intelligents.",
            ogTitle: "Irbe7 - L'actualité de la bourse de Tunis",
            ogType: 'website',
            ogUrl: environment.apiUrl,
            ogDescription:
 "Suivez l'actualité boursiére et financiére en temps réel avec Irbe7.com. Analyses de marché, indices boursiers, actions, devises, matières premières et plus encore. la source d'information pour les investisseurs intelligents.",           
  ogImage: 'https://d3b156xx8s447.cloudfront.net/Logo/LogoIrbe7',
            canonicalLink: environment.apiUrl,
            twitterTitle: "Irbe7 - L'actualité de la bourse de Tunis",
            twitterDescription:
 "Suivez l'actualité boursiére et financiére en temps réel avec Irbe7.com. Analyses de marché, indices boursiers, actions, devises, matières premières et plus encore. la source d'information pour les investisseurs intelligents.",            
 twitterImage: 'https://d3b156xx8s447.cloudfront.net/Logo/LogoIrbe7',
        });
  // Générer les schémas structurés
                this.articleSchemaService.generateGlobalWebPageSchema({
                    url: environment.apiUrl,
                    name: "Irbe7 - L'actualité de la bourse de Tunis",
                    description: "Suivez l'actualité boursiére et financiére en temps réel avec Irbe7.com. Analyses de marché, indices boursiers, actions, devises, matières premières et plus encore. la source d'information pour les investisseurs intelligents.",
                    isPartOf: {
                        name: 'Irbe7',
                        url: environment.apiUrl,
                    },
                });
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.isNavigating = true;
            } else if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                this.isNavigating = false;
            }
        });
    }
}
